
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M43.155 7.02c-2.2.7-4.7 1.2-6.8 2.1-1.4.6-1.4 1-1.8 2.4-.3.8-.5 1.7-.8 2.5h-5.3c-3.3 0-8.4-1-11.5.1-2.9 1.1-1.8 5-1.5 7.3 1.2 9.1 1.4 18.9 3.6 27.8 1 4 5.4 2.7 8.7 2.7 2.9 0 8.3 1.3 9.8-1.7 1.1-2.4.9-6.1 1.2-8.6.7-5.6 1.4-11.1 2.1-16.7.3-2.2 2-7.7.4-9.8-1.2-1.5-3.6-1-5.3-1h-.5c.1-.4.3-1.2.5-1.7 0 .2.7-.1 1.3-.3 2.1-.6 4.2-1.3 6.3-1.9.8-.4.6-3.5-.4-3.2zm-26.7 9.9c.3-.3 5.8.3 6.4.3h5.6c1.4 0 2.9-.1 4.4-.1l-2.1 6.9c-.2-.1-.5-.1-.7-.1-4.2-.8-8.6-.4-12.6.7-.6-2.4-1.6-7.2-1-7.7zm21.5 19.2c-.4 3.4-.3 7.7-1.4 11-.5 1.6.4 1.1-1.4 1.7-1.6.5-4.5 0-6.2 0-1.9 0-7.6.9-8.7-.4-1.2-1.4-.9-6.8-1.1-8.6-.5-4.1-1-8.1-1.5-12.2 5.7-1.4 11.1-1 16.8.7.6.2 2.8 1.1 4.3 1.1-.2 2.2-.5 4.5-.8 6.7zm1-18.9c1.9.2 1-.7 1.3.8.3 1.2-.4 3.2-.6 4.4-.2 1.3-.3 2.6-.5 3.9-.3-.3-1.3-.2-1.9-.3-1.7-.3-3.4-1-5.1-1.5.8-2.5 1.5-4.9 2.3-7.4 1.5-.1 3-.1 4.5.1z"}})])
          )
        }
      }
    